module.exports = __webpack_public_path__ + "static/media/申报端PC内页（如登录页）.2c40eb2b.png";